import { render, staticRenderFns } from "./RecordStoreTable.vue?vue&type=template&id=cc3c07ec&scoped=true"
import script from "./RecordStoreTable.vue?vue&type=script&lang=js"
export * from "./RecordStoreTable.vue?vue&type=script&lang=js"
import style0 from "./RecordStoreTable.vue?vue&type=style&index=0&id=cc3c07ec&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3c07ec",
  null
  
)

export default component.exports